var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"perks py-6"},[_c('HomeBenefits',{staticClass:"py-0",attrs:{"heading":_vm.$t('contributor.intro.benefits.heading'),"benefits":_vm.perks}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }